<!--
  Контейнер карточки пользователя для сайдбара бекофиса: грузит юзера из стора
  и отдаёт вьюхе SidebarUserCard. В плашках — роли (бекофис живёт ролями).
-->
<template>
  <SidebarUserCard
    :theme="theme"
    :stateSidebar="stateSidebar"
    :user="user"
    :loading="loading"
    :badges="badges"
  />
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue'

  import SidebarUserCard from '@martyrs/src/modules/auth/views/components/blocks/SidebarUserCard.vue'

  import { auth } from '@martyrs/src/modules/auth/views/store/auth.js'
  import { users } from '@martyrs/src/modules/auth/views/store/users.js'

  defineProps({
    theme: {
      type: String,
      default: 'light'
    },
    stateSidebar: {
      type: Boolean,
      default: false
    }
  })

  const loading = ref(true)
  const user = ref(null)

  const badges = computed(() =>
    (user.value?.roles || []).map(role => [role.icon, role.name].filter(Boolean).join(' '))
  )

  onMounted(async () => {
    try {
      if (auth.state.user?._id) {
        await users.actions.read({ _id: auth.state.user._id })
        user.value = users.state.current
      }
    } catch (err) {
      console.error('Failed to load user:', err)
    } finally {
      loading.value = false
    }
  })
</script>
